import { useMemo } from 'react';
import { useAnalyticsQuery } from './useAnalyticsQuery';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export const useCockpitData = ({ baslangic, bitis, firma } = {}) => {
  const params = useMemo(() => {
    const p = new URLSearchParams();
    if (baslangic) p.set('baslangic', baslangic);
    if (bitis) p.set('bitis', bitis);
    if (firma) p.set('firma', firma);
    return p.toString();
  }, [baslangic, bitis, firma]);

  const key = `cockpit:${params}`;

  return useAnalyticsQuery(key, async ({ signal }) => {
    const token = localStorage.getItem('access_token');
    const res = await fetch(`${API}/api/reports/executive-cockpit?${params}`, {
      signal,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (res.status === 403) throw new Error('Yetkiniz yok');
    if (!res.ok) throw new Error(`Hata: ${res.status}`);
    return res.json();
  }, [params]);
};
